import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientInvoicesPage from "@/pages/client/ClientInvoicesPage";

export const Route = createFileRoute("/client/invoices")({
  head: () => pageHead("Client · Invoices", "AKIVA client · invoices portal.", "/client/invoices", true),
  component: ClientInvoicesPage,
});
